import React from 'react';
import ReactLoading from 'react-loading';

const Example = ({ type, color,height,width }) => (
	<ReactLoading type={type} color={color} height={50} width={50} />
);

export default Example;